import { PureComponent } from 'react';

type MetaDataType = {
  tagName: string;
  name?: string;
  content?: string;
  names?: string;
  property?: string;
};

type MetaTagsPurePropTypes = {
  title: string;
  description?: string;
  metaData?: MetaDataType[];
};

type MetaTagsPureStateTypes = {
  metaData: MetaDataType[];
};

class MetaTagsPure extends PureComponent<
  MetaTagsPurePropTypes,
  MetaTagsPureStateTypes
> {
  private previousTitle: string | undefined;

  private previousDescription: any;

  static defaultProps: {
    title: string;
    description: string;
    metaData: MetaDataType[];
  } = {
    title: '',
    description: '',
    metaData: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      metaData: [],
    };
  }

  componentDidMount() {
    this.previousTitle = document.title;
    this.previousDescription = this.getDescriptionContent();

    this.updateMeta();
    this.setMetaTags();
  }

  componentDidUpdate() {
    this.updateMeta();
  }

  componentWillUnmount() {
    if (this.previousTitle != null) {
      document.title = this.previousTitle;
    }
    this.updateDescription(this.previousDescription);
    this.removeMetaTags();
  }

  getDescriptionElement = () => {
    if (!document.querySelector) {
      return null;
    }

    let element: HTMLMetaElement | null = document.querySelector(
      'meta[name=description]',
    );

    if (!element) {
      element = document.createElement('meta');
      element.name = 'description';
      element.content = '';
      document.head.appendChild(element);
    }

    return element;
  };

  getDescriptionContent = () => {
    const element = this.getDescriptionElement();

    return element ? element.content : '';
  };

  updateDescription = (newDescriptionContent) => {
    const element = this.getDescriptionElement();

    if (element && element.content !== newDescriptionContent) {
      element.content = newDescriptionContent;
    }
  };

  removeMetaTags = () => {
    const { metaData } = this.state;

    metaData.forEach(({ tagName, ...props }) => {
      Object.entries(props).forEach(([key, prop]) => {
        const metaElement = document.querySelector(
          `${tagName}[${key}="${prop}"]`,
        );

        if (metaElement) {
          document.head.removeChild(metaElement);
        }
      });
    });
  };

  setMetaTags = () => {
    const { metaData } = this.props;

    if (metaData) {
      this.setState({ metaData });

      metaData.forEach(({ tagName, ...props }) => {
        const metaElement = document.createElement(tagName);

        Object.entries(props).forEach(([key, prop]) => {
          metaElement.setAttribute(key, prop);
        });

        document.head.appendChild(metaElement);
      });
    }
  };

  updateMeta = () => {
    const { title, description } = this.props;

    document.title = title;

    this.updateDescription(description);
  };

  render() {
    return null;
  }
}

export default MetaTagsPure;
